import React from 'react';
import PropTypes from 'prop-types';

import { composeClassName } from '../../utils/common';

import withMessage from '../../withMessage.jsx';
import AvatarImage from '../../utils/AvatarImage.jsx';
import { createMessage } from '../../messageHelpers';

const OperatorMessage = props => {
  const {
    id,
    type,
    renderText,
    originalText,
    nickname,
    imgParams,
    messageTime,
    lastEditedTimeComponent,
    isLastInGroup,
    isFirstInGroup,
    messageViewType,
    nextMessageParams,
    contextMenuForOperatorMessages,
  } = props;

  const res = (
    <div className={composeClassName(type, isFirstInGroup, isLastInGroup, nextMessageParams)}>

      <AvatarImage {...{ messageViewType, imgParams, nickname }} />

      <div className="message-content">

        {
          isFirstInGroup
            && (
              <p className="author">
                {nickname}
              </p>
            )
        }
        { messageTime }

        <div className="message-text">
          {renderText ? renderText('p') : createMessage(props).renderText('p')}

          {lastEditedTimeComponent} {/* TODO: перенести в TextMessage */}
        </div>
      </div>
    </div>
  )
  /* TODO: мне не нравиться использование contextMenuForOperatorMessages */
  return contextMenuForOperatorMessages
    ? contextMenuForOperatorMessages({ children: res, id, originalText, nickname })
    : res
};

if (process.env.NODE_ENV !== 'production') {
  OperatorMessage.propTypes = {
    nickname: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    isLastInGroup: PropTypes.bool.isRequired,
    isFirstInGroup: PropTypes.bool.isRequired,
    messageViewType: PropTypes.string,
    imgParams: PropTypes.object,
    messageTime: PropTypes.node,
    lastEditedTimeComponent: PropTypes.node,
    type: PropTypes.string,
    originalText: PropTypes.string,
    renderText: PropTypes.func,
    nextMessageParams: PropTypes.object,
    contextMenuForOperatorMessages: PropTypes.func,
    currentTalkerNickname: PropTypes.string,
  };
}

export default withMessage(OperatorMessage);
